(function() {

$('.banner-grid__grid.contains-media').each(function(){  
      var highestBox = 0;
      $('.banner-grid__item__text', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.banner-grid__item__text',this).height(highestBox);
}); 
  
$(".product-form__input__radio-label").click(function(){
    setTimeout(function () {
      var get_ids_show = $(".rq-get-id").val();
      var get_ids_match =  $(".rq-variant-metafiled-get").attr('attr_id_variant_get');
       $(".rq-variant-metafiled-get").filter(function() {
         $(this).toggle($(this).text().toLowerCase().indexOf(get_ids_show) > 1);
      });
      
      $('.banner-grid__grid.contains-media').each(function(){  
      var highestBox = 0;
      $('.banner-grid__item__text', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.banner-grid__item__text',this).height(highestBox);
    }); 
      
    }, 1000);  
});

/*RQ! gift card script STARTS*/
$(".rq-click-on-gift-app").click(function(){
     $(".mytime-widget-button-wrapper a").trigger('click');
});  
$(".rq-click-on-gift-app2").click(function(){
     $(".mytime-widget-button-wrapper a").trigger('click');
});   
/*RQ! gift card script ENDS*/  
  
/*RQ! book script STARTS*/
$(".rq-click-on-book-app").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
});  
$(".rq-click-on-book-app2").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
});  
$(".rq-click-on-book-app-bg").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
});   
$(".rq-services-parallax-1 a.dsgn-pck__button.dsgn-pck__button-primary").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
});    
$(".rq-services-parallax-2 a.dsgn-pck__button.dsgn-pck__button-primary").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
}); 
$(".rq-click-on-book-app--parallax").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
});  
$(".rq-click-on-book-app-img-simple").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
});    
  
$(".rq-services-image-text-1 a.button").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
}); 
$(".rq-services-image-text-2 a.button").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
}); 
$(".rq-services-image-text-3 a.button").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
}); 
$(".rq-services-image-text-4 a.button").click(function(){
     $(".mytime-widget-button-wrapper-v2 a").trigger('click');
}); 
/*RQ! book script ENDS*/  

/*RQ! Links target blank STARTS*/  
  /* Wholesale - Header and Footer */
$('a[href="https://wholesale.vbarber.shop/"]').attr('target', '_blank'); 
  /* Download the app - Header and Footer */
$('a[href="https://qrco.de/bbcemi"]').attr('target', '_blank');
  /* Franchise - Header and Footer */
$('a[href="https://vbarbershopfranchise.com/"]').attr('target', '_blank');
  /* Locations template - Virtual Tour CTA */
$('.rq-locations-virtual-tour-parallax a').attr('target', '_blank');
  /* Join our franchise family template - Discovery call CTA */
$('.rq-join-our-franchise-family-discovery-call-parallax a').attr('target', '_blank');
/*RQ! Links target blank ENDS*/  

/*RQ! code for "Modal pop-up using metafield button code" STARTS*/
$(".rq-click-on-book-app-location").click(function(){
     $(".rq-button-trigger-location-page .mytime-widget-button-wrapper-v2 a").trigger('click');
}); 
/*RQ! code for "Modal pop-up using metafield button code" ENDS*/
  
/*RQ! code for "Modal pop-up with URL #reservation slug" STARTS*/
var pageURL = $(location).attr("href");
var page_reservation_tag = pageURL.split("#");
var page_reservation_tag_word = page_reservation_tag[1]; 
if(page_reservation_tag_word == "reservation") {
  $(".rq-button-trigger-location-page .mytime-widget-button-wrapper-v2 a").trigger('click');
}
/*RQ! code for "Modal pop-up with URL #reservation slug" ENDS*/  

/*RQ! code for "Giftcard and Reservation automatic pop-ups" STARTS*/  
var pageURL = $(location).attr("href");
var page_reservation_tag = pageURL.split("#");
var page_reservation_tag_word = page_reservation_tag[1]; 
if(page_reservation_tag_word == "reservation") {
    $(".mytime-widget-button-wrapper-v2 a").trigger('click');
}  

var pageURL = $(location).attr("href");
var page_reservation_tag = pageURL.split("#");
var page_reservation_tag_word = page_reservation_tag[1]; 
if(page_reservation_tag_word == "giftcard") {
    $(".mytime-widget-button-wrapper a").trigger('click');
}  

$(".dsgn-pck__button-primary").click(function(){  
  var pageURL = $(this).attr("href");
  var page_reservation_tag = pageURL.split("#");
  var page_reservation_tag_word = page_reservation_tag[1]; 
  if(page_reservation_tag_word == "reservation") {
    $(".mytime-widget-button-wrapper-v2 a").trigger('click');
  }  
  if(page_reservation_tag_word == "giftcard") {
    $(".mytime-widget-button-wrapper a").trigger('click');
  } 
}); 
$(".dsgn-pck__button-secondary").click(function(){  
  var pageURL = $(this).attr("href");
  var page_reservation_tag = pageURL.split("#");
  var page_reservation_tag_word = page_reservation_tag[1]; 
  if(page_reservation_tag_word == "reservation") {
    $(".mytime-widget-button-wrapper-v2 a").trigger('click');
  }  
  if(page_reservation_tag_word == "giftcard") {
    $(".mytime-widget-button-wrapper a").trigger('click');
  } 
});    
/*RQ! code for "Giftcard and Reservation automatic pop-ups" ENDS*/  

/*RQ! code for "Increments set up for the B2B catalog" STARTS*/  
  setTimeout(function () {
    var step_increment = $(".rq-b2b-quantity").attr('step_increment');
    $(".rq-b2b-quantity").attr('step', step_increment);
  }, 1500);

  
 
  
 
 /*   setTimeout(function () {
    $('.drawer__cart-items-wrapper .cart-items tr').each(function(index) {
      var get_add_attr = $(this).attr('get_step');
      $(this).find(".gb_quantity__input"+index).attr('step', get_add_attr);
    });
   }, 3000);   */

  
  $('body').on('click', '.cart-drawer quantity-input.quantity', function(){  
    setTimeout(function () {
     $(".rq-update_data-trigger").trigger('click'); 
    }, 2500);  
 });  
 $('body').on('keypress', ".cart-drawer .quantity__input[type='number']", function(){  
    setTimeout(function () {
     $(".rq-update_data-trigger").trigger('click'); 
    }, 2500);  
  }); 
 
  $('body').on('click', '.cart-drawer cart-remove-button button', function(){  
    setTimeout(function () {
     $(".rq-update_data-trigger").trigger('click'); 
    }, 2500);  
 }); 
/*RQ! code for "Increments set up for the B2B catalog" ENDS*/  
  $("body").click(function(){ //alert("fvf");  

/*var dataType = [];
$(".complementary__item").each(function() {
var data = {}; // Create a new object for each iteration
data['id'] = $(this).find('.complementary-variant-id').val();
data['quantity'] = $(this).find('.quantity__input').val();
//console.log(data);
dataType.push(data);
});
const newData = {
items : [...dataType]
}

jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: newData,
dataType: 'json',
success: function(data) {
console.log(data);
alert('fv');
}
});*/

  /*  let formData = {
 'items': [{
  'id': 39874793144417,
  'quantity': 12
  },
          {
  'id': 39874792685665,
  'quantity': 16
  }]
};*/

    /*  fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(newData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});*/
  });
  
})();